import { Box } from '@wix/design-system';
import React from 'react';
import { WixLogo } from '@wix/premium-purchase-platform/@ui';
import {
  ResellerCoBrandedLogo,
  useAnonymous,
  useResellerBranding,
} from '@wix/package-picker-shared-eclipse';
import { useHasQuickPayPersistentChrome } from '../QuickPayLightbox/QuickPayLightboxChrome';
import { PromotionalMessage } from './PromotionalMessage';
import { SaleBanner } from '../SaleBanner';
import { SwitchPlanHeaderBanner } from './SwitchPlanHeaderBanner';

export const HeaderBanner = () => {
  const { isAnonymous } = useAnonymous();
  const { isResellerOffering, resellerBrandingInfo } = useResellerBranding();
  // In the Quick Pay lightbox the shell owns the strip/sale banner; drawing them here would double them up.
  const hasPersistentChrome = useHasQuickPayPersistentChrome();

  if (hasPersistentChrome) {
    return <SwitchPlanHeaderBanner />;
  }

  return (
    <>
      <Box
        minHeight="56px"
        height="56px"
        width="100%"
        verticalAlign="middle"
        paddingRight="SP3"
        boxSizing="border-box"
        direction="horizontal"
      >
        <Box flex={1} verticalAlign="middle" marginLeft="30px">
          {!isAnonymous &&
            (isResellerOffering && resellerBrandingInfo?.logo ? (
              <ResellerCoBrandedLogo logo={resellerBrandingInfo.logo} />
            ) : (
              <WixLogo skin="dark" height="17px" />
            ))}
        </Box>
        <Box align="center" verticalAlign="middle" direction="horizontal">
          <PromotionalMessage />
        </Box>
        <Box flex={1} />
      </Box>
      <SwitchPlanHeaderBanner />
      <SaleBanner />
    </>
  );
};
